import ChevronImage from "@assets/video_widget/Chevron.webp";
import ArticleCard from "@blocks/Card/ArticleCard";
import Heading from "@elements/Typography/Heading";
import { FEATURE_FLAG_LANDSCAPE_VIDEO } from "@helper/getEnvVariables";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import { HomeSectionArticlesPayload } from "@typings/PagePayloadType";
import { Link } from "react-router";

import LandscapeVideoSection from "./LandscapeVideoSection";

function getTamilSectionTitles(sectionName: string) {
  switch (sectionName) {
    case "singapore":
      return "சிங்க‌ப்பூர்";
    case "tamilnadu":
      return "தமிழ்நாடு";
    case "india":
      return "இந்தியா";
    case "world":
      return "உல‌க‌ம்";
    case "sports":
      return "விளையாட்டு";
    case "lifestyle":
      return "வாழ்வும் வளமும்";
    default:
      return "சிங்க‌ப்பூர்";
  }
}

const SectionPartition = ({
  sectionName,
  articlesPayload,
}: {
  sectionName: string;
  articlesPayload: ProcessedArticleData[] | undefined;
}) => {
  // const { data: sectionArticlesMap } = useSwrApi<ProcessedArticleMapList>(
  //   `latest-section-articles?size=3&section=${sectionName}`,
  // );
  // const sectionArticlesList = sectionArticlesMap
  //   ? Object.keys(sectionArticlesMap).map(
  //       (mapKey: string) => sectionArticlesMap[mapKey],
  //     )
  //   : [];
  const tamilSectionName = getTamilSectionTitles(sectionName);
  return (
    <div className="lg:w-[calc(50%-20px)] border-b border-pink-300 lg:border-b-0">
      <Heading
        Element="h2"
        className="text-red-100 text-2.5md font-bold mt-5 hover:underline hover:cursor-pointer hover:text-red-200"
      >
        <Link reloadDocument to={`/${sectionName}`} target="_blank">
          {tamilSectionName}
          <img
            alt="toggle-button-chevie"
            height={26}
            width={26}
            className="pl-100 inline"
            src={ChevronImage}
          />
        </Link>
      </Heading>
      {articlesPayload?.map((article, i, row) => (
        <ArticleCard
          key={article.id}
          displayWidth={385}
          displayHeight={257}
          {...article}
          elements={{ hasParagraph: i === 0 ? true : false, hasDate: true }}
          overrideStyle={{
            cardWrapper:
              i === 0
                ? "flex-col"
                : i + 1 === row.length
                  ? "flex-row flex-row-reverse border-b-0"
                  : "flex-row flex-row-reverse",
            paragraphStyle:
              i === 0 ? "h-[calc(100%+10px)] overflow-hidden" : "",
            titleStyle:
              "font-semibold font-primary text-2sm text-gray-100 hover:text-gray-100",
            imageWrapperStyle:
              i === 0
                ? "w-full max-w-82 lg:w-82 min-h-55 lg:min-h-62 lg:max-h-62 sm:w-full"
                : "w-31.5 max-w-44 lg:w-40 lg:h-23 lg:max-h-23",
            contentWrapper: "gap-2.5",
            titleWrapper: "gap-0",
            imageStyle:
              i === 0
                ? " h-55 lg:h-62 sm:h-100"
                : "h-23 lg:h-23 w-31.5 lg:w-full",
          }}
          refMedium={sectionName}
        />
      ))}
    </div>
  );
};

export const SectionArticles = (
  sectionArticles: HomeSectionArticlesPayload,
) => {
  return (
    <div>
      <div className="flex flex-wrap gap-5 border-b-0 lg:border-b border-pink-300">
        <SectionPartition
          key="singapore"
          sectionName="singapore"
          articlesPayload={sectionArticles.singaporeArticles}
        />
        <SectionPartition
          key="tamilnadu"
          sectionName="tamilnadu"
          articlesPayload={sectionArticles.tamilnaduArticles}
        />
      </div>
      {FEATURE_FLAG_LANDSCAPE_VIDEO && <LandscapeVideoSection />}
      <div className="flex flex-wrap gap-5 border-b-0 lg:border-b border-pink-300">
        <SectionPartition
          key="india"
          sectionName="india"
          articlesPayload={sectionArticles.indiaArticles}
        />
        <SectionPartition
          key="world"
          sectionName="world"
          articlesPayload={sectionArticles.worldArticles}
        />
      </div>
      <div className="flex flex-wrap gap-5 border-b-0 lg:border-b border-pink-300">
        <SectionPartition
          key="sports"
          sectionName="sports"
          articlesPayload={sectionArticles.sportsArticles}
        />
        <SectionPartition
          key="lifestyle"
          sectionName="lifestyle"
          articlesPayload={sectionArticles.lifestyleArticles}
        />
      </div>

      {/* {sections.map((row, index) => (
        <div
          key={index}
          className="flex flex-wrap gap-5 border-b-0 lg:border-b border-pink-300"
        >
          {row.map((sectionName) => (
            <SectionPartition key={sectionName} sectionName={sectionName} />
          ))}
        </div>
      ))} */}
    </div>
  );
};
